import React from "react";
import styled from "styled-components";
import { content } from "@glossy";
import Panel from "@ui-kit/popover/panel";
import Chips from "@radarly/components/filterbar/panels/chips";
import { useFilterbarChoices } from "@radarly/core/filters/use-cases";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import { Clause } from "@radarly/models/clause";
import { isClauseEmpty } from "@radarly/models/clause/is";
import { refineClauseWithInnerClause } from "@radarly/models/clause/refiner";
import { transformClauseFromField } from "@radarly/models/clause/transformer";
import { FullFacet } from "@radarly/models/facets";
import { Choice, Status } from "@radarly/models/filters";
import { getNextClauseFromStatusAndValue } from "./clause";

interface IProps {
  clause: Clause;
  facet: FullFacet;
  setClause: (clause: Clause) => void;
  hasTitle?: boolean;
  onApply: () => void;
  onCancel?: () => void;
  validateLabel?: string;
  className?: string;
}

const Description = styled.div`
  margin-bottom: 24px;
  color: ${(props) => content(props, "secondary")};
`;

const RadarlyFilterbarPanelsChips = ({
  setClause,
  clause,
  facet,
  hasTitle,
  onApply,
  onCancel,
  validateLabel,
  className,
}: IProps) => {
  const locale = useCurrentUserLocale();
  const onStatusChange = (choice: Choice, status: Status) => {
    setClause(
      getNextClauseFromStatusAndValue(clause, facet, choice.id, status)
    );
  };

  const { choices } = useFilterbarChoices(clause, facet);
  const onClear = () => {
    setClause(
      refineClauseWithInnerClause(
        clause,
        transformClauseFromField(
          {
            [facet.id]: [],
          },
          facet.custom ? [facet.id] : []
        )
      )
    );
  };

  return (
    <Panel
      locale={locale}
      onClear={onClear}
      hasTitle={hasTitle}
      title={tr(locale, "FILTERBAR::PANEL::FILTERBY", {
        filter: facet.label,
      })}
      size={choices.length < 5 ? "s" : "m"}
      onApply={onApply}
      onCancel={onCancel}
      disabled={onCancel ? isClauseEmpty(clause) : false}
      validateLabel={validateLabel}
      className={className}
    >
      {facet.description && <Description>{facet.description}</Description>}
      <Chips choices={choices} onSetChoices={onStatusChange} />
    </Panel>
  );
};

export default RadarlyFilterbarPanelsChips;
